/**
 * Created by pyt on 1/18/17.
 */
export const ADD_CREATIVEFILE_TO_CREATIVE = 'ADD_CREATIVEFILE_TO_CREATIVE';
export const CREATE_CREATIVE = 'CREATE_CREATIVE';
export const DELETE_CREATIVE = 'DELETE_CREATIVE';
export const SAVE_CREATIVE = 'SAVE_CREATIVE';
export const SAVE_CREATIVE_PREFETCH_ALL_SIZES_APPROVAL = 'SAVE_CREATIVE_PREFETCH_ALL_SIZES_APPROVAL';
export const SAVE_CREATIVE_PREFETCH_CACHE_TYPE = 'SAVE_CREATIVE_PREFETCH_CACHE_TYPE';
export const UPDATE_CREATIVE = 'UPDATE_CREATIVE';
export const UPDATE_CREATIVE_PREFETCH_TYPE = 'UPDATE_CREATIVE_PREFETCH_TYPE';
export const UPDATE_CREATIVE_PREFETCH_SOURCE = 'UPDATE_CREATIVE_PREFETCH_SOURCE';
export const UPDATE_CREATIVE_PREFETCH_ID = 'UPDATE_CREATIVE_PREFETCH_ID';
export const UPDATE_CREATIVE_PREFETCH_ALL_SIZES_APPROVAL = 'UPDATE_CREATIVE_PREFETCH_ALL_SIZES_APPROVAL';
export const UPDATE_CREATIVE_PREFETCH_CACHE_TYPE = 'UPDATE_CREATIVE_PREFETCH_CACHE_TYPE';
export const UPDATE_CREATIVE_IS_FALLBACK = 'UPDATE_CREATIVE_IS_FALLBACK';
export const SAVE_CREATIVES = 'SAVE_CREATIVES';
export const SAVE_EXTERNAL_CREATIVES = 'SAVE_EXTERNAL_CREATIVES';

export const DELETE_CREATIVEFILE = 'DELETE_CREATIVEFILE';
export const DELETE_CREATIVE_LINEITEM = 'DELETE_CREATIVE_LINEITEM';

export const SAVE_CREATIVEFILE = 'SAVE_CREATIVEFILE';
export const UPDATE_CREATIVEFILES_LIST = 'UPDATE_CREATIVEFILES_LIST';
export const UPDATE_CREATIVEFILE_APPROVAL_STATES = 'UPDATE_CREATIVEFILE_APPROVAL_STATES';

export const UPDATE_CREATIVE_PREFETCH_SIZE_APPROVAL_STATES = 'UPDATE_CREATIVE_PREFETCH_SIZE_APPROVAL_STATES';
